"use client";

import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import { LanguageDropdown } from "@/components/common/LanguageDropdown";

const InstagramIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C9.5556 3 9.2496 3.0102 8.2896 3.054C7.3314 3.0978 6.6768 3.2502 6.1044 3.4728C5.5044 3.6984 4.9602 4.0524 4.5102 4.5108C4.05253 4.96028 3.69831 5.5041 3.4722 6.1044C3.2508 6.6768 3.0978 7.332 3.054 8.2902C3.0108 9.2496 3 9.555 3 12C3 14.445 3.0102 14.7504 3.054 15.7104C3.0978 16.6686 3.2502 17.3232 3.4728 17.8956C3.6984 18.4956 4.0524 19.0398 4.5108 19.4898C4.96029 19.9475 5.50411 20.3017 6.1044 20.5278C6.6768 20.7498 7.3314 20.9022 8.2896 20.946C9.2496 20.9898 9.5556 21 12 21C14.4444 21 14.7504 20.9898 15.7104 20.946C16.6686 20.9022 17.3232 20.7498 17.8956 20.5272C18.4956 20.3016 19.0398 19.9476 19.4898 19.4892C19.9475 19.0397 20.3017 18.4959 20.5278 17.8956C20.7498 17.3232 20.9022 16.6686 20.946 15.7104C20.9898 14.7504 21 14.4444 21 12C21 9.5556 20.9898 9.2496 20.946 8.2896C20.9022 7.3314 20.7498 6.6768 20.5272 6.1044C20.3012 5.50384 19.947 4.95979 19.4892 4.5102C19.0397 4.05253 18.4959 3.69831 17.8956 3.4722C17.3232 3.2508 16.668 3.0978 15.7098 3.054C14.7504 3.0108 14.445 3 12 3ZM12 4.6218C14.403 4.6218 14.688 4.6308 15.6372 4.674C16.5144 4.7142 16.9908 4.86 17.3082 4.9842C17.7282 5.1468 18.0282 5.3424 18.3432 5.6568C18.6582 5.9718 18.8532 6.2718 19.0158 6.6918C19.1394 7.0092 19.2858 7.4856 19.326 8.3628C19.3692 9.312 19.3782 9.597 19.3782 12C19.3782 14.403 19.3692 14.688 19.326 15.6372C19.2858 16.5144 19.14 16.9908 19.0158 17.3082C18.8718 17.6991 18.6419 18.0528 18.3432 18.3432C18.0528 18.642 17.6992 18.8718 17.3082 19.0158C16.9908 19.1394 16.5144 19.2858 15.6372 19.326C14.688 19.3692 14.4036 19.3782 12 19.3782C9.5964 19.3782 9.312 19.3692 8.3628 19.326C7.4856 19.2858 7.0092 19.14 6.6918 19.0158C6.30087 18.8718 5.9472 18.6419 5.6568 18.3432C5.35811 18.0528 5.12828 17.6991 4.9842 17.3082C4.8606 16.9908 4.7142 16.5144 4.674 15.6372C4.6308 14.688 4.6218 14.403 4.6218 12C4.6218 9.597 4.6308 9.312 4.674 8.3628C4.7142 7.4856 4.86 7.0092 4.9842 6.6918C5.1468 6.2718 5.3424 5.9718 5.6568 5.6568C5.94716 5.35803 6.30085 5.12819 6.6918 4.9842C7.0092 4.8606 7.4856 4.7142 8.3628 4.674C9.312 4.6308 9.597 4.6218 12 4.6218Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15.003C11.6057 15.003 11.2152 14.9254 10.8508 14.7744C10.4865 14.6235 10.1554 14.4023 9.87658 14.1235C9.59773 13.8446 9.37653 13.5136 9.22561 13.1492C9.0747 12.7849 8.99702 12.3944 8.99702 12C8.99702 11.6057 9.0747 11.2152 9.22561 10.8508C9.37653 10.4865 9.59773 10.1554 9.87658 9.87659C10.1554 9.59774 10.4865 9.37654 10.8508 9.22562C11.2152 9.07471 11.6057 8.99703 12 8.99703C12.7965 8.99703 13.5603 9.31342 14.1235 9.87659C14.6866 10.4398 15.003 11.2036 15.003 12C15.003 12.7965 14.6866 13.5603 14.1235 14.1235C13.5603 14.6866 12.7965 15.003 12 15.003ZM12 7.37403C10.7731 7.37403 9.59649 7.86141 8.72895 8.72896C7.8614 9.5965 7.37402 10.7731 7.37402 12C7.37402 13.2269 7.8614 14.4036 8.72895 15.2711C9.59649 16.1387 10.7731 16.626 12 16.626C13.2269 16.626 14.4036 16.1387 15.2711 15.2711C16.1386 14.4036 16.626 13.2269 16.626 12C16.626 10.7731 16.1386 9.5965 15.2711 8.72896C14.4036 7.86141 13.2269 7.37403 12 7.37403ZM17.9718 7.29003C17.9718 7.58005 17.8566 7.85818 17.6515 8.06325C17.4465 8.26833 17.1683 8.38353 16.8783 8.38353C16.5883 8.38353 16.3102 8.26833 16.1051 8.06325C15.9 7.85818 15.7848 7.58005 15.7848 7.29003C15.7848 7.00002 15.9 6.72188 16.1051 6.51681C16.3102 6.31174 16.5883 6.19653 16.8783 6.19653C17.1683 6.19653 17.4465 6.31174 17.6515 6.51681C17.8566 6.72188 17.9718 7.00002 17.9718 7.29003Z"
      fill="currentColor"
    />
  </svg>
);

const LinkedinIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 4.32353V19.6765C21 20.0275 20.8606 20.3641 20.6123 20.6123C20.3641 20.8606 20.0275 21 19.6765 21H4.32353C3.97251 21 3.63586 20.8606 3.38765 20.6123C3.13944 20.3641 3 20.0275 3 19.6765V4.32353C3 3.97251 3.13944 3.63586 3.38765 3.38765C3.63586 3.13944 3.97251 3 4.32353 3H19.6765C20.0275 3 20.3641 3.13944 20.6123 3.38765C20.8606 3.63586 21 3.97251 21 4.32353ZM8.29412 9.88235H5.64706V18.3529H8.29412V9.88235ZM8.53235 6.97059C8.53375 6.77036 8.49569 6.57182 8.42035 6.3863C8.34502 6.20078 8.23387 6.03191 8.09328 5.88935C7.95268 5.74678 7.78537 5.6333 7.60091 5.5554C7.41646 5.47749 7.21846 5.43668 7.01824 5.43529H6.97059C6.5634 5.43529 6.17289 5.59705 5.88497 5.88497C5.59705 6.17289 5.43529 6.5634 5.43529 6.97059C5.43529 7.37777 5.59705 7.76828 5.88497 8.05621C6.17289 8.34413 6.5634 8.50588 6.97059 8.50588C7.17083 8.51081 7.37008 8.47623 7.55696 8.40413C7.74383 8.33202 7.91467 8.2238 8.0597 8.08565C8.20474 7.94749 8.32113 7.78212 8.40223 7.59897C8.48333 7.41582 8.52755 7.21848 8.53235 7.01824V6.97059ZM18.3529 13.2071C18.3529 10.6606 16.7329 9.67059 15.1235 9.67059C14.5966 9.6442 14.0719 9.75644 13.6019 9.9961C13.1318 10.2358 12.7328 10.5945 12.4447 11.0365H12.3706V9.88235H9.88235V18.3529H12.5294V13.8476C12.4911 13.3862 12.6365 12.9283 12.9339 12.5735C13.2313 12.2186 13.6567 11.9954 14.1176 11.9524H14.2182C15.06 11.9524 15.6847 12.4818 15.6847 13.8159V18.3529H18.3318L18.3529 13.2071Z"
      fill="currentColor"
    />
  </svg>
);

export const Footer = () => {
  const { featureFlags } = useFeatureFlags();
  const router = useRouter();

  const handleHashLink = (e, href) => {
    e.preventDefault();
    const [path, hash] = href.split("#");
    const targetPath = path || "/";

    const scrollToHash = () => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return true;
      }
      return false;
    };

    if (window.location.pathname === targetPath) {
      scrollToHash();
    } else {
      router.push(targetPath);
      const interval = setInterval(() => {
        if (scrollToHash()) clearInterval(interval);
      }, 100);
      setTimeout(() => clearInterval(interval), 5000);
    }
  };

  const socialLinks = [
    {
      name: "Instagram",
      Icon: InstagramIcon,
      href: "https://www.instagram.com/keystone.apps/",
    },
    {
      name: "LinkedIn",
      Icon: LinkedinIcon,
      href: "https://www.linkedin.com/showcase/keystone-apps",
    },
  ];

  const footerSections = [
    {
      title: "PRODUCTS",
      links: [
        { name: "Loyalty & Rewards", href: "/loyalty" },
        { name: "Product Options & Variants", href: "/product-options" },
        { name: "AI SEO", href: "/ai-seo" },
      ],
    },
    {
      // The docs outrank every other section of the property, yet the only
      // path into them was this single Help Center link. Deep links give the
      // three getting-started pages a crawlable route from every page.
      title: "SUPPORT",
      links: [
        { name: "Help Center", href: "https://key-stone.app/docs/" },
        {
          name: "Loyalty Docs",
          href: "https://key-stone.app/docs/loyalties/getting-started/introduction.html",
        },
        {
          name: "Product Options Docs",
          href: "https://key-stone.app/docs/product-options/introduction/overview.html",
        },
        {
          name: "AI SEO Docs",
          href: "https://key-stone.app/docs/aiSEO/getting-started.html",
        },
        { name: "Contact Us", href: "/#contact" },
      ],
    },
    {
      title: "RESOURCES",
      links: [
        featureFlags.blogsEnabled !== false && {
          name: "Blogs",
          href: "/blogs",
        },
        featureFlags.blogsEnabled !== false && {
          name: "All Articles",
          href: "/blogs/archive",
        },
        featureFlags.caseStudiesEnabled !== false && {
          name: "Case Studies",
          href: "/resources/case-studies",
        },
        featureFlags.guidesEnabled !== false && {
          name: "Guides",
          href: "/resources/guides",
        },
        featureFlags.ebooksEnabled !== false && {
          name: "eBooks",
          href: "/resources/ebooks",
        },
        featureFlags.researchPapersEnabled !== false && {
          name: "Research Papers",
          href: "/resources/research-papers",
        },
        { name: "Changelog", href: "/resources/changelog" },
        { name: "Free Tools", href: "/tools" },
      ].filter(Boolean),
    },
    {
      title: "LEGAL",
      links: [
        { name: "Privacy Policy", href: "/privacy-policy" },
        { name: "Terms of Use", href: "/terms-of-use" },
        { name: "Data Processing Addendum", href: "/data-processing-addendum" },
        { name: "Security", href: "/security" },
      ],
    },
  ];

  const brands = [
    {
      name: "Shop Circle",
      logo: "/images/footer-logos/sc-logo.svg",
      width: 97,
      height: 21,
    },
    {
      name: "HulkApps",
      logo: "/images/footer-logos/hulkapps-wordmark.svg",
      width: 89,
      height: 22,
    },
    {
      name: "Accentuate",
      logo: "/images/footer-logos/accentuate-brandmark.svg",
      width: 111,
      height: 29,
    },
    {
      name: "Order Printer",
      logo: "/images/footer-logos/opp.svg",
      width: 129,
      height: 23,
    },
    {
      name: "Sky Pilot",
      logo: "/images/footer-logos/sky-pilot.svg",
      width: 109,
      height: 30,
    },
    {
      name: "krakenD",
      logo: "/images/footer-logos/krakend.svg",
      width: 104,
      height: 20,
    },
    {
      name: "releasit",
      logo: "/images/footer-logos/releasit-wordmark.svg",
      width: 89,
      height: 20,
    },
    {
      name: "Wholesale Helper",
      logo: "/images/footer-logos/wholesale-helper-brandmark.svg",
      width: 75,
      height: 26,
    },
    {
      name: "aiden",
      logo: "/images/footer-logos/aiden-logo.svg",
      width: 71,
      height: 26,
    },
    {
      name: "CartHook",
      logo: "/images/footer-logos/ch-brandmark.svg",
      width: 111,
      height: 15,
    },
    {
      name: "Opinew",
      logo: "/images/footer-logos/opinew-brandmark.svg",
      width: 99,
      height: 27,
    },
    {
      name: "506",
      logo: "/images/footer-logos/506-logo.svg",
      width: 61,
      height: 30,
    },
  ];

  return (
    <footer className="relative z-10 bg-[#1e1e1e]">
      {/* Wrapper with horizontal padding */}
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-20 pt-16 pb-24">
        <div className="flex flex-col gap-12">
          {/* Explore Our Brands */}
          <div className="flex flex-col gap-8 pb-12 border-b border-white/10">
            <p className="text-[20px] font-bold leading-6 tracking-[-0.04px] uppercase text-[#a4a4a4]">
              Explore our brands
            </p>

            {/* Brand Logos Strip - infinite marquee */}
            <div className="overflow-hidden">
              <div className="flex items-center w-max animate-marquee">
                {[0, 1].map((copy) => (
                  <div key={copy} className="flex items-center gap-8 pr-8">
                    {brands.map((brand) => (
                      <div
                        key={`${brand.name}-${copy}`}
                        className="flex-shrink-0"
                      >
                        <Image
                          src={brand.logo}
                          alt={brand.name}
                          width={brand.width}
                          height={brand.height}
                          className="object-contain brightness-150 hover:brightness-200 transition-[filter] duration-300"
                          style={{ width: brand.width, height: brand.height }}
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Main Footer Content */}
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-12">
            {/* Left: About Keystone */}
            <div className="flex flex-col gap-16 w-full lg:w-[340px] xl:w-[379px] shrink-0">
              <div className="flex flex-col justify-between min-h-[234px]">
                {/* Keystone Logomark */}
                <Image
                  src="/brands/footer/keystone-logomark.svg"
                  alt="Keystone"
                  width={221}
                  height={46}
                  className="object-contain"
                  style={{ width: 221, height: 46 }}
                />

                {/* About Text */}
                <div className="flex flex-col gap-3 mt-8">
                  <h3 className="text-[28px] font-medium leading-9 tracking-[-0.28px] text-[#f1f8f4]">
                    About Keystone
                  </h3>
                  <p className="text-[16px] leading-6 tracking-[-0.032px] text-[#a4a4a4]">
                    Keystone simplifies growth for Shopify merchants through
                    easy-to-use, smart solutions.
                  </p>
                </div>
              </div>

              {/* Social Links */}
              <div className="flex items-center gap-6 opacity-75">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.href}
                    className="text-[#909090] hover:text-[#a4a4a4] transition-colors duration-300"
                    target="_blank"
                    rel="noopener noreferrer"
                    title={social.name}
                  >
                    <social.Icon />
                  </a>
                ))}
              </div>
            </div>

            {/* Vertical Divider */}
            <div className="hidden lg:block w-px bg-white/10 self-stretch" />

            {/* Right: Link Columns */}
            <div className="grid grid-cols-2 xl:grid-cols-4 gap-x-8 gap-y-12 flex-1 min-w-0">
              {footerSections.map((section) => (
                <div key={section.title} className="min-w-0">
                  <h4 className="text-[14px] font-semibold leading-4 tracking-[1px] uppercase text-[#f1f8f4] mb-8 lg:mb-12">
                    {section.title}
                  </h4>

                  <ul className="flex flex-col gap-6">
                    {section.links.map((link) => (
                      <li key={link.name}>
                        {link.href.includes("#") ? (
                          <a
                            href={link.href}
                            onClick={(e) => handleHashLink(e, link.href)}
                            className="text-[16px] leading-6 tracking-[-0.032px] text-[#a4a4a4] hover:text-white transition-colors duration-300"
                          >
                            {link.name}
                          </a>
                        ) : (
                          <Link
                            href={link.href}
                            {...(link.href.startsWith("http")
                              ? { target: "_blank", rel: "noopener noreferrer" }
                              : {})}
                            className="text-[16px] leading-6 tracking-[-0.032px] text-[#a4a4a4] hover:text-white transition-colors duration-300"
                          >
                            {link.name}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/10 pt-6 flex flex-wrap items-center justify-between gap-4">
            {/* #6c6c6c on #1e1e1e is 3.17:1 — below the 4.5:1 WCAG AA floor
                for text under 18pt. #8b8b8b clears it at 4.6:1. */}
            <p className="text-[14px] font-semibold leading-[15px] tracking-[-0.03px] text-[#909090]">
              2026 &copy; Keystone. All rights reserved.
            </p>
            <LanguageDropdown />
          </div>
        </div>
      </div>
    </footer>
  );
};
